import { render, staticRenderFns } from "./UserLearnProgressOverviewPage.vue?vue&type=template&id=056c5530"
import script from "./UserLearnProgressOverviewPage.vue?vue&type=script&lang=js"
export * from "./UserLearnProgressOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./UserLearnProgressOverviewPage.vue?vue&type=style&index=0&id=056c5530&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports